export class BaseOption {
  value: any;
  text: any;
  disabled?: any;

  constructor(value: any, text?: any, disabled?: any) {
    this.value = value;
    this.text = text === undefined ? value : text;
    this.disabled = disabled;
  }
}
